import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useEffect, useState } from "react";
import { gql, useReactiveVar, useApolloClient } from "@apollo/client";
import { useAdvancedScreenQuery } from "../types";
import WithfriendsTitleBar, { WithfriendsAction } from "./WithfriendsTitleBar";
import { currentBusinessIdVar, currentShopifyVersionVar, dummyFunc, waitForNetworkIdle } from "../helpers/client";
gql `
query AdvancedScreen($id: ID!) {
  business(id: $id) {
    id
    dashboardLink
  }
}
`;
const AdvancedScreen = ({ useSyncShopifyDataMutation = dummyFunc, openAction }) => {
    var _a;
    const client = useApolloClient();
    const [isCacheReset, setIsCacheReset] = useState(false);
    const currentBusinessId = useReactiveVar(currentBusinessIdVar);
    const currentShopifyVersion = useReactiveVar(currentShopifyVersionVar);
    useEffect(() => {
        if (client && !isCacheReset) {
            const resetCache = async () => {
                try {
                    await waitForNetworkIdle().catch(() => { });
                    await client.clearStore();
                    setIsCacheReset(true);
                }
                catch (error) {
                    console.error("Error resetting Apollo cache:", error);
                }
            };
            resetCache();
        }
    }, [client, isCacheReset]);
    const { data, loading, error } = useAdvancedScreenQuery({
        variables: {
            id: currentBusinessId
        },
        skip: !currentBusinessId || !isCacheReset,
    });
    if (!currentBusinessId || !isCacheReset)
        return null;
    return (_jsxs("div", { className: "max-w-none w-full -my-8 -mx-4", style: { height: "100vh" }, children: [_jsx(WithfriendsTitleBar, { action: WithfriendsAction.Advanced, useSyncShopifyDataMutation: useSyncShopifyDataMutation }), _jsx("iframe", { style: {
                    width: currentShopifyVersion == 2 ? "100%" : "100vw",
                    height: "100%",
                    overflow: "hidden",
                }, src: ((_a = data === null || data === void 0 ? void 0 : data.business) === null || _a === void 0 ? void 0 : _a.dashboardLink) + (openAction ? ",Open_Action=" + openAction : "") })] }));
};
export default AdvancedScreen;
